import React from "react";
import { Link } from "react-router-dom";
import SectionLayout from "@/pages/SectionLayout";

/**
 * Architecture — Service 3 of 3: The World (A Living Infrastructure).
 * Formerly "Custom AI Agent Architecture".
 */
const ArchitectureAgents = () => {
  return (
    <SectionLayout>
      <h2 className="glass-panel__title" data-testid="section-title">
        THE WORLD: A LIVING INFRASTRUCTURE
      </h2>
      <p className="glass-panel__body" data-testid="section-body">
        Ultimately, we do not just deliver software; we hand over a living,
        breathing ecosystem. This new architecture integrates seamlessly
        into your daily operations, granting you massive operational scale
        while fiercely protecting the aesthetic integrity that defines you.
      </p>
      <p className="glass-panel__body" data-testid="section-body-coda">
        You own the story. We build the stage.
      </p>
      <div className="glass-panel__nav">
        <Link to="/" className="glass-panel__btn" data-testid="btn-home">
          Home
        </Link>
        <Link
          to="/architecture/engine"
          className="glass-panel__btn glass-panel__btn--back"
          data-testid="btn-back"
        >
          The Engine
        </Link>
        <Link
          to="/lets-talk"
          className="glass-panel__btn glass-panel__btn--right"
          data-testid="btn-next"
        >
          Let&apos;s Talk
        </Link>
      </div>
    </SectionLayout>
  );
};

export default ArchitectureAgents;
